import { render, staticRenderFns } from "./ProjectShowExtraOptionsTab.vue?vue&type=template&id=11903cc3"
import script from "./ProjectShowExtraOptionsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectShowExtraOptionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports